import type { TUpdateVenueCategory } from './types';
import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const updateVenueCategory = async ({
  categoryId,
  newDisplayOrder,
  newParentId,
  newName,
}: TUpdateVenueCategory): Promise<Response> => {
  const uri = `${API_URL}/venues/categories/${categoryId}`;

  return fetch(uri, {
    method: 'PATCH',
    body: JSON.stringify({
      display_order: newDisplayOrder,
      parent_category_id: newParentId,
      name: newName,
    }),
    cache: 'reload',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
};
